// extracted by mini-css-extract-plugin
module.exports = {"hint":"Menu_hint__2ppl2","hintItem":"Menu_hintItem__2rutv","bold":"Menu_bold__1Nb1x","fakeCreateOption":"Menu_fakeCreateOption__26cbK"};